// extracted by mini-css-extract-plugin
export default {"root":"IconWatched_root__pNDCJ"};